var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayerSkipNext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3778 30C28.2128 30 28.0545 29.9369 27.9378 29.8247C27.8211 29.7125 27.7556 29.5602 27.7556 29.4015L27.7556 24.2984L18.7036 29.5096C18.4945 29.6319 18.2551 29.698 18.0104 29.7009C17.7657 29.7038 17.5247 29.6434 17.3125 29.5261C16.8459 29.2717 16.5558 28.778 16.5558 28.242L16.5558 17.3945C16.5558 16.857 16.8459 16.3648 17.3125 16.1104C17.5247 15.9932 17.7657 15.9329 18.0104 15.9359C18.2551 15.9388 18.4945 16.0049 18.7036 16.1273L27.7556 21.3381L27.7556 16.235C27.7556 16.0763 27.8211 15.924 27.9378 15.8118C28.0545 15.6996 28.2128 15.6365 28.3778 15.6365C28.5428 15.6365 28.7011 15.6996 28.8178 15.8118C28.9344 15.924 29 16.0763 29 16.235L29 29.4015C29 29.5602 28.9344 29.7125 28.8178 29.8247C28.7011 29.9369 28.5428 30 28.3778 30Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayerSkipNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/player-skip-next.b5d73ad2b73b571cf98a0b1127bced1e.svg";